import { NgModule } from '@angular/core'
import { SharedModule } from '../../../common/modules/shared';

// Import components
import { BusAttendanceComponent } from './BusAttendanceComponent'
import { BusAttendanceRouter } from './BusAttendanceRouting'
import { ScheduleModule } from 'primeng/primeng'
import { StudentLocationComponent } from './student-location/StudentLocationComponent';
import {  DialogModule } from 'primeng/primeng'

@NgModule({
    declarations: [
        BusAttendanceComponent,
        StudentLocationComponent
    ],
    imports: [
        SharedModule,
        ScheduleModule,
        BusAttendanceRouter,
        DialogModule
    ]
})

export class BusAttendanceModule {

}


// WEBPACK FOOTER //
// ./src/bus/parent/bus-attendance/BusAttendanceModule.ts